<tt-divider *ngIf="!('mobile' | mediaQuery)" ttRememberId="w_transportareas.dividers">
    <tt-divider-columns>
        <tt-divider-pane ttSize="30">
            <tt-card>
                <tt-button-goto ttText="transportareas_new" ttIcon="far fa-plus" (ttClick)="openAddModal()"></tt-button-goto>
            </tt-card>
            <ng-container *ngIf="!!areas">
                <tt-toast *ngIf="areas.length === 1" ttType="warning" ttTitle="no_transportareas_registered" ttTranslateTitle></tt-toast>
                <tt-list *ngIf="areas.length > 1" ttRadioSelection [(ttSelectedId)]="selectedId" [ttData]="areas" ttGoto="false"></tt-list>
            </ng-container>
        </tt-divider-pane>
        <tt-divider-pane ttSize="70">
            <tt-transport-area-menu
                *ngIf="!!selectedId && !!params"
                [params]="{ transportarea_keyno: selectedId, stockplace_id: params.stockplace_id }"
                (submit)="onTransportAreaSubmitted($event)"
            ></tt-transport-area-menu>
        </tt-divider-pane>
    </tt-divider-columns>
</tt-divider>
<ng-container *ngIf="('mobile' | mediaQuery) && !!params">
    <tt-card>
        <tt-button-goto ttText="transportareas_new" ttIcon="far fa-plus" ttGoto="transportarea" [ttGotoParms]="{ transportarea_keyno: '0', stockplace_id: params.stockplace_id }"></tt-button-goto>
    </tt-card>
    <ng-container *ngIf="!!areas">
        <tt-toast *ngIf="areas.length === 1" ttType="warning" ttTitle="no_transportareas_registered" ttTranslateTitle></tt-toast>
        <tt-list *ngIf="areas.length > 1" [ttData]="areas"></tt-list>
    </ng-container>
</ng-container>
